module.exports = __webpack_public_path__ + "img/instr_0.f304a3fa.svg";